import { render } from "./BusActivities.vue?vue&type=template&id=6cd8b7be&scoped=true"
import script from "./BusActivities.vue?vue&type=script&lang=js"
export * from "./BusActivities.vue?vue&type=script&lang=js"

import "./BusActivities.vue?vue&type=style&index=0&id=6cd8b7be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd8b7be"]])

export default __exports__